

// var urls = function(){
//   var REBATE_INIT = "ac=init";
// }

// export default {    
//   istest(){
//       console.log("this is test")
//   },
//   init(){
//     return "ac=init";
//   }
// }

var urls = {
  REBATE_INIT: 'rebate/cross_index.php?ct=rebatev3&ac=init',// 红包初始化
  REBATE_USER: 'rebate/cross_index.php?ct=rebatev3&ac=user',// 红包用户信息
  REBATE_SHOW: 'rebate/cross_index.php?ct=rebatev3&ac=show',// 获取红包数据
  REBATE_MONEY: 'rebate/cross_index.php?ct=rebatev3&ac=money',// 金额接口，获取红包活动用户已领取的金额时调用接口
  REBATE_BONUS: 'rebate/cross_index.php?ct=rebatev3&ac=bonus',// 获取红包活动列表兑换金额时调用接口
  REBATE_RECEIVE: 'rebate/cross_index.php?ct=rebatev3&ac=receive',// 领取红包
  REBATE_WXAUTH: 'rebate/cross_index.php?ct=rebatev3&ac=wxAuth',// 微信绑定二维码
  REBATE_AUTHSTATUS: 'rebate/cross_index.php?ct=rebatev3&ac=authStatus',// 获取红包活动用户授权状态信息时调用接口
  REBATE_EXCHANGE: 'rebate/cross_index.php?ct=rebatev3&ac=exchangeWx',// 兑换
  REBATE_RECEIVE_LOG: 'rebate/cross_index.php?ct=rebatev3&ac=receiveLog',// 领取记录
  REBATE_EXCHANGELOG: 'rebate/cross_index.php?ct=rebatev3&ac=exchangeLog',// 兑换记录
  REBATE_GRABLOG: 'rebate/cross_index.php?ct=rebatev3&ac=grabRebateLog',// 抢红包记录接口
  REBATE_GIFT: 'rebate/cross_index.php?ct=rebatev3&ac=gift',// 红包活动v3礼包接口
  REBATE_GRABREBATEUSER: 'rebate/cross_index.php?ct=rebatev3&ac=grabRebateUser',// 抢红包用户信息接口
  REBATE_EXCHANGEALI: 'rebate/cross_index.php?ct=rebatev3&ac=exchangeAli',// 支付宝兑换接口
  REBATE_ALIAUTH: 'rebate/cross_index.php?ct=rebatev3&ac=aliAuth',// 支付宝授权接口

  
  REBATE_EDITPASSWORD: 'common/cross_index.php?ct=user&ac=editPassword',// 修改密码
  REBATE_SEND: 'common/cross_index.php?ct=sms&ac=send',// 获取验证码
  REBATE_INFO: 'common/cross_index.php?ct=user&ac=info',// 用户信息接口
  PAY_DETAIL: 'common/cross_index.php?ct=user&ac=detail',//用户充值信息接口
  CUSTOMER_SERVICE: 'common/cross_index.php?ct=info&ac=customerService',//客服接口
  
  
}
export default urls


// WEBPACK FOOTER //
// ./src/SdkV3/network/urls.js